/**
 * #605: Wohin führt ein Klick auf eine Meldung in der Pille?
 * Ziel ist immer der Datensatz selbst (Dokument, Vorgang, Eingang …), nicht nur die Übersicht.
 * Ergebnis geht an handleSearchNavigation (App.tsx): bekannte Typen (ticket, rechnung, email,
 * termin, …) löst es selbst auf, sonst navigiert es zu `pfad`.
 */
export interface MeldungsZiel { pfad: string; id: string; typ: string }

interface MeldungRef { link_pfad: string | null; referenz_id: string | null; referenz_typ: string | null }

export function meldungsZiel(n: MeldungRef): MeldungsZiel | null {
  const id = n.referenz_id ?? '';
  const typ = n.referenz_typ ?? '';
  if (id) {
    const enc = encodeURIComponent(id);
    // Unterschriften-Vorgang direkt im Reiter „Signieren“ öffnen
    if (typ === 'signatur') return { pfad: `/admin/dokumente?tab=sign&bearbeiten=${enc}`, id, typ };
    // Einzelnes Dokument: /admin/dokumente/:id öffnet den Aktenschrank mit Objekt und Datei
    if (typ === 'dokument' || typ === 'dokumente') return { pfad: `/admin/dokumente/${enc}`, id, typ: 'dokument' };
    if (typ === 'selbstauskunft') return { pfad: `/admin/mieterselbstauskunft?eingang=${enc}`, id, typ };
    if (typ) return { pfad: n.link_pfad ?? '', id, typ };
  }
  // Ohne Bezug wenigstens die passende Seite öffnen (vorher passierte beim Klick nichts)
  return n.link_pfad ? { pfad: n.link_pfad, id: '', typ: '' } : null;
}
